<p-confirmDialog [transitionOptions]="'170ms'" [acceptButtonStyleClass]="'btn-dialog-danger'"
  [rejectButtonStyleClass]="'btn-dialog-default'"></p-confirmDialog>
<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="row">
        <div class="col-md-4">
          <lib-page-header page-title="ASSINATURAS" image-title="assets/img/signature.png">
          </lib-page-header>
        </div>
        <div class="col-md-8">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/assinaturas']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="nome" class="required">Nome</label>
          <input #nome id="nome" formControlName="nome" type="text" class="form-control font-weight-bold">
        </div>
        <div class="form-group col-md-6 mt-3">
          <div class="checkbox checbox-switch switch-primary text-right">
            <label style="margin: 0; text-align: left;">
              <input type="checkbox" formControlName="ativo" /><span></span>Ativo
            </label>
          </div>
        </div>
      </div>
      <hr />
      <div class="row mb-2">
        <div class="col-12">
          <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-primary">
            <i class="fa fa-plus"></i> Incluir Pessoa
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table table-sm table-eddy">
            <thead>
              <tr>
                <th style="width: 60%" scope="col">Pessoa</th>
                <th scope="col">Cargo</th>
                <th style="width: 100px" scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of entidade.pessoas; let idx = index">
                <!-- pessoa -->
                <td *ngIf="!item.editavel">
                  {{item.pessoa?.cpf_cnpj | CPF}} {{item.pessoa?.nome}}
                </td>
                <td *ngIf="item.editavel">
                  <p-autoComplete [(ngModel)]="item.pessoa" [ngModelOptions]="{standalone: true}"
                    [forceSelection]="true" [autoHighlight]="true" [field]="pessoaAutoComplete.conversor"
                    [suggestions]="pessoaAutoComplete.lista" *ngIf="pessoaAutoComplete"
                    (completeMethod)="pessoaAutoComplete.filtrar($event)" inputStyleClass="form-control form-control-sm"
                    minLength="2" [style]="{ width: 'calc(100% - 36px)', float: 'left' }">
                    <ng-template let-pessoa pTemplate="item">
                      {{pessoa.cpf_cnpj | CPF}} - {{pessoa.nome}}
                    </ng-template>
                  </p-autoComplete>
                  <button class="btn btn-sm btn-outline-secondary float-right" type="button" data-toggle="modal"
                    style="border-bottom-left-radius: 0px;  border-top-left-radius: 0px;" data-target="#dialogPessoa">
                    <i class="fa fa-user-plus"></i>
                  </button>
                </td>

                <!-- cargo -->
                <td *ngIf="!item.editavel">{{item.cargo}}</td>
                <td *ngIf="item.editavel">
                  <input [(ngModel)]="item.cargo" [ngModelOptions]="{standalone: true}" type="text"
                    class="form-control form-control-sm">
                </td>

                <td class="text-right">
                  <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
                    <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
                  </button>
                  <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary">
                    <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
                  </button>
                  <button *ngIf="!item.editavel" (click)="editar(item)" class="btn btn-sm btn-outline-primary mr-2">
                    <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                  </button>
                  <button *ngIf="!item.editavel" (click)="remover(item, idx)" class="btn btn-sm btn-outline-primary">
                    <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<lib-pessoa-cadastro-dlg [login]="login"></lib-pessoa-cadastro-dlg>